import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/core/styles";
import Switch from "@material-ui/core/Switch";
import PropTypes from "prop-types";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import InputFormat from "../../../../partials/inputForm";
import DescriptionComponent from "../../../descriptionComponent";
import MapComponent from "../../../leafletMap";
import SelectedLanguage from "../../../selectedLanguage";
import InputAddress from "../../../suggestAddress";
import { informationStyle } from "./styles";

class Information extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: false,
      imgSelected: "", // hình đã chọn nhưng ko sử dụng
      displayMap: "none",
      service: {
        isActive: 1,
        pointSystem: 1,
        name: "",
        minPrice: 0,
        maxPrice: 0,
        phone: "",
        mobile: "",
        support: '{"japanese":0,"korean":0}',
        address: "",
        website: "",
        currencyCode: "VND",
        countryCode: "",
        district: "",
        city: "",
        description: "",
        lat: 10.797336,
        lng: 106.679428,
        workingDays:
          '{"monday":{"from":"07:30","to":"18:00","off":0},"tuesday":{"from":"08:30","to":"18:00","off":0},"wednesday":{"from":"08:30","to":"18:00","off":0},"thursday":{"from":"08:30","to":"18:00","off":0},"friday":{"from":"08:30","to":"18:00","off":0},"saturday":{"from":"08:30","to":"18:00","off":0},"sunday":{"from":"08:30","to":"18:00","off":1}}',
      },
      file: "",
      fileLogo: "",
    };
    this.imgURL = "";
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillMount() {
    this.props.onRef(null);
  }

  async componentDidMount() {
    this.props.onRef(this);
  }

  componentWillReceiveProps(nextProps) {}

  onChange = (value) => {
    var service = this.state.service;
    service.isActive = value ? 1 : 0;
    this.setState({ service });
  };

  handleChange = (e) => {
    var name = e.target.name;
    var value = e.target.value;
    var service = this.state.service;
    if (e.target.type === "checkbox") {
      value = e.target.checked ? 1 : 0;
    }
    service[name] = value;
    this.setState({ service });
  };

  handleSubComponentChange = (name, value) => {
    var service = this.state.service;
    service[name] = value;
    this.setState({ service });
  };

  async handleSubmit() {
    var { t } = this.props;
    await this.myGoogleMap.viewOnGoogleMap(this.state.service.address);
    if (!this.myGoogleMap.state.checked) {
      this.props.handleOpenSnackBar(
        t("service_admin_createservice_information_address_invalid"),
        "warning"
      );
    } else if (!this.state.service.name) {
      this.props.handleOpenSnackBar(
        t(
          "service_admin_createservice_information_please_enter_name_spa",
          "warning"
        )
      );
    } else if (!this.state.service.phone) {
      this.props.handleOpenSnackBar(
        t(
          "service_admin_createservice_information_please_enter_phone_spa",
          "warning"
        )
      );
    } else {
      this.props.handleSubmit({
        service: this.state.service,
        files: this.state.file,
        logo: this.state.fileLogo,
      });
    }
  }
  handleChangeAddress = (value) => {
    let { service } = this.state;
    service = { ...service, ...value };
    this.setState({ service });
  };
  fileUpload = (file) => {
    this.setState({ file: file && file.file });
  };
  fileUploadLogo = (file) => {
    this.setState({ fileLogo: file && file.file });
  };
  onEnterAddress = (event) => {
    if (event.key === "Enter") {
      const { service = {} } = this.state;
      this.myGoogleMap.viewOnGoogleMap(service.address);
    }
  };
  render() {
    const { classes, t } = this.props;
    const { service = {} } = this.state;

    let support = service.support ? JSON.parse(service.support) : null;
    return (
      <div>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={4} md={4}>
            <FormControlLabel
              control={
                <Checkbox
                  // disabled={disabled}
                  checked={service.pointSystem === 1 ? true : false}
                  onChange={(e) =>
                    this.handleChange(e.target.name, e.target.checked)
                  }
                  name="pointSystem"
                  color="primary"
                />
              }
              label={t("service_ownerspa_servicedetail_feature_point_system")}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={4}>
            <FormControlLabel
              control={
                <Checkbox
                  // disabled={disabled}
                  checked={service.usingTax === 1 ? true : false}
                  onChange={(e) =>
                    this.handleChange(e.target.name, e.target.checked)
                  }
                  name="usingTax"
                  color="primary"
                />
              }
              label={t("service_ownerspa_servicedetail_feature_using_tax")}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={4}>
            <div className="edit-service-submit-active">
              <FormControlLabel
                control={
                  <Switch
                    classes={{
                      switchBase: classes.iOSSwitchBase,
                      bar: classes.iOSBar,
                      icon: classes.iOSIcon,
                      iconChecked: classes.iOSIconChecked,
                      checked: classes.iOSChecked,
                    }}
                    disableRipple
                    checked={service.isActive === 1 ? true : false}
                    onChange={this.handleChange}
                    name="isActive"
                  />
                }
                label={
                  <label className={classes.label}>
                    {t("service_admin_createservice_information_active")}
                  </label>
                }
              />
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <InputFormat
              required
              id="multiline-flexible"
              label={t("service_admin_createservice_information_name_service")}
              name="name"
              value={service.name}
              onChange={this.handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <InputFormat
              id="multiline-flexible"
              label="Website"
              name="website"
              value={service.website}
              onChange={this.handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <InputFormat
              required
              id="multiline-flexible"
              label={t("service_admin_createservice_information_phone")}
              name="phone"
              value={service.phone}
              onChange={this.handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <InputFormat
              id="multiline-flexible"
              label={t("service_admin_createservice_information_mobile")}
              name="mobile"
              value={service.mobile}
              onChange={this.handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <SelectedLanguage
              support={support}
              handleSubComponentChange={this.handleSubComponentChange}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <InputFormat
              id="multiline-flexible"
              label={t("service_admin_createservice_information_min_price")}
              name="minPrice"
              value={service.minPrice}
              onChange={this.handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <InputFormat
              id="multiline-flexible"
              label={t("service_admin_createservice_information_max_price")}
              name="maxPrice"
              value={service.maxPrice}
              onChange={this.handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <InputFormat
              id="multiline-flexible"
              label={t("service_admin_createservice_information_currency")}
              name="currency"
              value={service.currencyCode}
              onChange={this.handleChange}
            />
          </Grid>
          <Grid item xs={24} sm={12}>
            <InputAddress
              required
              label={t("servicebranch_editbranch_address")}
              name="address"
              onKeyPress={this.onEnterAddress}
              value={service.address}
              handleChange={this.handleChangeAddress}
              className={classes.textField}
              InputProps={{
                className: classes.input,
              }}
              InputLabelProps={{
                className: classes.label,
              }}
              auto={true}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <InputFormat
              disabled
              label={t("service_ownerspa_servicedetail_feature_state")}
              name="city"
              value={service.state}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <InputFormat
              disabled
              label={t("service_ownerspa_servicedetail_feature_country")}
              name="district"
              value={service.country}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <InputFormat
              disabled
              label={t("service_ownerspa_servicedetail_feature_city")}
              name="city"
              value={service.city}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <InputFormat
              disabled
              label={t("service_ownerspa_servicedetail_feature_district")}
              name="district"
              value={service.district}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <MapComponent
              onRef={(googleMap) => (this.myGoogleMap = googleMap)}
              // handleSubComponentChange={this.handleSubComponentChange}
              handleChangeAddress={this.handleChangeAddress}
              handleOpenSnackBar={this.props.handleOpenSnackBar}
              lat_center={Number(service.lat || 0)}
              lng_center={Number(service.lng || 0)}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <DescriptionComponent
              onRef={(id) => (this.DescriptionComponent = id)}
              handleSubComponentChange={this.handleSubComponentChange}
              description={service.description || null}
              title={t("service_admin_createservice_information_description")}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <Button
              variant="contained"
              component="span"
              color="primary"
              onClick={this.handleSubmit}
              className={classes.button}
            >
              {" "}
              {t("service_admin_createservice_information_save")}
            </Button>
          </Grid>
        </Grid>
      </div>
    );
  }
}

Information.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapState = (state) => ({
  uploadState: state.upload,
  serviceState: state.service,
});

const mapDispatch = (dispatch) => ({
  uploadDispatch: dispatch.upload,
});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(informationStyle, { withTheme: true })(Information)
  )
);
